module.exports = __webpack_public_path__ + "static/media/balls-sports.5234c196.png";